import { render } from "./VacunaPersTabla01.vue?vue&type=template&id=05653de4&scoped=true"
import script from "./VacunaPersTabla01.vue?vue&type=script&lang=js"
export * from "./VacunaPersTabla01.vue?vue&type=script&lang=js"

import "./VacunaPersTabla01.vue?vue&type=style&index=0&id=05653de4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05653de4"]])

export default __exports__